import React from 'react';
import { Modal, Button, Typography } from 'antd';
import { variantTokens } from '../../../theme/theme';

const { Text } = Typography;

// Costanti dei colori
const PRIMARY = variantTokens.primary;
const LIGHT_GREY = '#f5f5f5';

/**
 * MediumModal - A reusable 700px modal component for forms and more complex content
 * 
 * @param {boolean} visible - Controls if the modal is visible
 * @param {function} onClose - Function called when modal is closed
 * @param {string} title - Modal title
 * @param {React.ReactNode} children - Custom content to display in the modal
 * @param {function} onConfirm - Function called when confirm button is clicked
 * @param {string} cancelText - Text for the cancel button
 * @param {string} confirmText - Text for the confirm button
 * @param {boolean} hideFooter - If true, the footer buttons will be hidden
 * @returns {React.ReactElement}
 */

const MediumModal = ({
    visible = false,
    onClose,
    title = "Medium Modal",
    children,
    onConfirm,
    cancelText = "Close",
    confirmText = "Confirm",
    hideFooter = false,
    centered = true
}) => {
    const handleCancel = () => {
        if (onClose) onClose();
    };

    const handleConfirm = () => {
        if (onConfirm) onConfirm();
        handleCancel();
    };

    return (
        <Modal
            centered={centered}
            title={title}
            open={visible}
            onCancel={handleCancel}
            footer={hideFooter ? null : [
                <Button
                    key="back"
                    onClick={handleCancel}
                    style={{
                        fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                        height: 'auto',
                        padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                        minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                    }}
                >
                    {cancelText}
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={handleConfirm}
                    style={{
                        backgroundColor: PRIMARY,
                        borderColor: PRIMARY,
                        fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                        height: 'auto',
                        padding: 'clamp(0.25rem, 1vw, 0.5rem) clamp(0.5rem, 2vw, 1rem)',
                        minHeight: 'clamp(2rem, 5vw, 2.25rem)'
                    }}
                >
                    {confirmText}
                </Button>
            ]}
            width="clamp(18.75rem, 90vw, 43.75rem)"
            styles={{
                wrapper: {
                    marginTop: 'clamp(1rem, 5vh, 3rem)'
                },
                header: {
                    padding: 'clamp(0.75rem, 3vw, 1.25rem)',
                    fontSize: 'clamp(1rem, 3vw, 1.25rem)'
                },
                body: {
                    maxHeight: '70vh',
                    margin: '-1.5rem',
                    marginTop: '.5rem',
                    padding: '1.5rem',
                    overflowY: 'auto'
                },
                footer: {
                    padding: 'clamp(0.5rem, 2vw, 1rem) clamp(0.75rem, 3vw, 1.25rem)'
                }
            }}
        >
            <div style={{ padding: 'clamp(0.75rem, 3vw, 1.25rem) 0' }}>
                {children || (
                    <>
                        <Text style={{ fontSize: 'clamp(0.875rem, 2.5vw, 1rem)' }}>This is a medium-sized modal (700px).</Text>
                        <p style={{ marginTop: 'clamp(0.5rem, 2vw, 0.9375rem)', fontSize: 'clamp(0.75rem, 2vw, 0.875rem)' }}>
                            Use this type of modal for forms, wizards or displaying
                            more detailed information that requires more space.
                        </p>
                        <div style={{
                            height: 'clamp(5rem, 20vh, 9.375rem)',
                            backgroundColor: LIGHT_GREY,
                            borderRadius: 'clamp(0.125rem, 1vw, 0.25rem)',
                            padding: 'clamp(0.5rem, 2vw, 0.9375rem)',
                            marginTop: 'clamp(0.5rem, 2vw, 0.9375rem)'
                        }}>
                            <Text style={{ fontSize: 'clamp(0.75rem, 2vw, 0.875rem)' }}>Additional content area</Text>
                        </div>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default MediumModal; 